import _ from 'lodash'
import { observer } from 'mobx-react'
import React, { useState } from 'react'
import Modal from '../../Components/Modal'
import DataStore from '../../State/DataStore'
import { useNavigate } from '@tanstack/react-router'
import { handleEntityDelete } from '../../Utils/deleteEntity'

export default observer(({ contact, modalId }) => {
    const navigate = useNavigate()
    return (
        <Modal
            modalId={modalId}
            heading="Delete Contact"
            saveLabel={'Delete Contact'}
            onSave={() => handleEntityDelete(contact, 'contact', navigate)}
        >
            <p style={{ margin: '1em' }}>
                Are you sure you wish to delete <em>{contact.label}</em>?
            </p>
        </Modal>
    )
})
